module.exports = {"preselectDefaults":{"startHash":"/2/1/1","paymentFrequency":"12","numberOfClaims":"0","cara":{"coverageCodes":["ANSA","SDKA","FULY"]},"modelYear":"2005","make":"Mercedes-Benz","excessAmount":"6.913","annualMileage":"10.000","equipmentValue":"70.000","registrationNumber":"AAA","vehicleIdentificationNumber":"WDB1714561F055516","vehicleMakeId":"CEA9E6B30132BB61","recordedMileage":"200.000","model":"SLK","drivingExperience":"5","carLeased":false,"registrationNumberValid":true,"flow":"quick"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/packages/car/package.car-fdm-static.json
// module id = 640
// module chunks = 0